import { composeFetch } from '@library/http'
import { auth, composeRequest, addPath, setServiceUrl, setQueryParam } from '@library/http/requests'

import { RecipeAvailability } from './types'
import { extractCoreData } from '@library/http/src/parsers'

const getRecipeAvailabilityByDeliveryDateRequest = composeRequest(
  setServiceUrl('core'),
  addPath('recipes/availability'),
  setQueryParam('filters[delivery_date]', (deliveryDate: string) => deliveryDate),
  auth,
)

export const getRecipeAvailabilityByDeliveryDate = composeFetch(
  getRecipeAvailabilityByDeliveryDateRequest,
  extractCoreData<RecipeAvailability[]>(),
)
